import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

interface TeacherManagementConfigOptions {}

export const getTeacherManagementConfig = (options: TeacherManagementConfigOptions = {}): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			headerImage: '/svg/teacher-management.svg',
			title: 'Welcome to Teacher Management',
			subtitle: "Invite teachers and manage their assigned classes. Let's have a quick look around.",
			button: {
				label: 'Show me around',
				type: 'full-width' as const
			},
			modalPosition: 'center' as const,
			hasBackdrop: true
		},
		{
			type: 'tooltip' as const,
			target: '#invite-teachers-button',
			subtitle: 'Click here to invite any teachers by adding their emails.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#active-teachers',
			subtitle: 'Any teachers with an active account will show here along with their assigned classes.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#pending-button',
			subtitle:
				'The Pending tab will contain any teachers who have been invited but have not accepted their invitation to join your school.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#teacher-menu',
			subtitle:
				'Click here for additional actions such as assigning classes, granting admin status or removing teacher accounts.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'teacher-management-ftux',
		name: 'Teacher Management Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
